import { createVar, keyframes, style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

const slideInFromBottom = keyframes({
  from: {
    transform: "translateY(50px)",
    opacity: 0,
  },
  to: {
    transform: "translateY(0)",
    opacity: 1,
  },
});

export const progressBarContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const progressBar = style({
  borderRadius: vars.radii.m,
  backgroundColor: vars.colors.onSurfaceOpacityHigh,
  width: "100%",
  height: 12,
});

export const progressWidth = createVar();

export const progressBarFill = style({
  transition: "width 0.5s ease-in-out",
  borderRadius: vars.radii.m,
  background: vars.colors.blueLilacGradient,
  width: progressWidth,
  height: "100%",
});

export const progressBarLabel = style({
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.m,
});

export const summaryList = style({
  display: "flex",
  flexDirection: "column",
  paddingBottom: vars.space.l,
  textAlign: "left",
});

export const summaryItem = style({
  selectors: {
    "&:not(:last-child)": {
      borderBottom: vars.borders.outlineVariant,
      paddingBottom: vars.space.m,
    },
    "&:not(:first-child)": {
      paddingTop: vars.space.m,
    },
  },
});

export const summaryItemDisplay = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: vars.space.s,
});

export const summaryItemText = style({
  display: "flex",
  flexDirection: "column",
});

export const summaryItemLabel = style({
  color: vars.colors.onSurfaceVariant,
});

export const summaryItemValue = style({
  fontFamily: vars.fonts.bold,
});

export const summaryEditActions = style({
  display: "flex",
  justifyContent: "flex-end",
  gap: vars.space.xs,
  marginTop: vars.space.xs,
});

export const stepContainer = style({
  animation: `${slideInFromBottom} 300ms ease-out`,
});
